import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import makeStyles from "@mui/styles/makeStyles";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

import useAnnouncementStore from "announcementStore";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.warning["clr-100"],
    border: "1px solid",
    borderColor: theme.palette.warning["clr-300"],
    borderRadius: "4px",
    padding: theme.spacing(3, 5),
    marginBottom: theme.spacing(5),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(3),
  },
  message: {
    flex: 1,
  },
  closeBtn: {
    color: theme.palette.warning["clr-700"],
    padding: theme.spacing(1),
  },
}));

/**
 * Global announcement shown above the page header (Navbar) on every route when
 * the currently selected batch is one the user no longer has access to.
 * Self-hides for batches the user still has access to.
 */
export default function AnnouncementBanner() {
  const classes = useStyles();

  const selectedBatchId = useAnnouncementStore((s) => s.selectedBatchId);
  const removedBatches = useAnnouncementStore((s) => s.removedBatches);
  const dismissed = useAnnouncementStore((s) => s.dismissed);
  const loadEnrollments = useAnnouncementStore((s) => s.loadEnrollments);
  const setSelectedBatchId = useAnnouncementStore((s) => s.setSelectedBatchId);
  const dismiss = useAnnouncementStore((s) => s.dismiss);

  React.useEffect(() => {
    // Stay in sync with the globally persisted batch selection on every route.
    const stored = sessionStorage.getItem("selectedBatch");
    if (stored && stored !== selectedBatchId) setSelectedBatchId(stored);
    loadEnrollments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removedBatchName = selectedBatchId
    ? removedBatches[selectedBatchId]
    : undefined;

  const show = Boolean(removedBatchName) && !dismissed[selectedBatchId];

  if (!show) return null;

  return (
    <Box className={classes.root} role="alert">
      <WarningAmberOutlinedIcon style={{ color: "#664100", fontSize: "20px" }} />
      <Typography
        variant="body01-bold"
        color="warning.clr-700"
        className={classes.message}
      >
        It seems you are removed from this batch, contact your institute or Admin
        for the access. Please switch to a batch where you have access.
      </Typography>
      <IconButton
        size="small"
        aria-label="Close announcement"
        className={classes.closeBtn}
        onClick={() => dismiss(selectedBatchId)}
      >
        <CloseRoundedIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
